/// <amd-module name="VSSUI/FilterBar" />
export * from "./Components/FilterBar/index";
